export default {
  rooms: [],
  pagination: {},
  room: {},
  setting: {},
  chat: {}
}
